import { AuthService } from 'projects/shared/services/auth.service';
import { LightModeService } from 'projects/shop/src/app/+shared/services/light-mode.service';
import {
  AfterViewInit,
  Component,
  computed,
  effect,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ProductType } from 'projects/shared/models/enums/productTypes.enum';
import { UserStoreProvider } from 'projects/shared/providers/user.provider';
import { ExchangeService } from 'projects/shared/services/exchange.service';
import { LoadingSpinnerService } from 'projects/shop/src/app/+shared/services/loading-spinner.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { getDateSubtraction, sortWallets } from 'projects/shared/utils/helpers';
import { Observable, Subscription, filter, noop, tap } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MainCategory, MainCategory1 } from 'projects/shared/models/category';
import {
  IActiveCurrency,
  Exchange,
} from 'projects/shared/models/interfaces/exchange.model';
import {
  AccountStatus,
  IUser,
  Rank,
} from 'projects/shared/models/interfaces/user.model';
import { WalletService } from 'projects/shared/services/wallet.service';
import { IWallet } from 'projects/shared/models/interfaces/wallet.model';
import { Currency } from 'projects/shared/models/exchange.model';
import { CategoryService } from 'projects/shared/services/category.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { SidebarModule } from 'primeng/sidebar';
import { CrispChatService } from 'projects/shared/services/crisp-chat.service';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';
import { BrowserService } from 'projects/shared/services/browser.service';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { NavNotificationsComponent } from './partials/nav-notifications/nav-notifications.component';
import { NavRegionalComponent } from './partials/nav-regional/nav-regional.component';
import { TrimStringPipe } from 'projects/admin/src/app/shared/pipes/trim-string.pipe';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { NavCartComponent } from './partials/nav-cart/nav-cart.component';
import { Store } from '@ngrx/store';
import { SelectCartQuantity } from './partials/nav-cart/store/cart.selectors';
import { SelectUser, SelectUserStatus } from 'projects/shop/src/app/modules/user-settings/components/profile/store/profile.selectors';
import { SelectRegionalCurrency, SelectRegionalLanguage } from './partials/nav-regional/store/regional-setting.selectors';
import { UserActions } from 'projects/shop/src/app/modules/user-settings/components/profile/store/profile.actions';
import { ThemeActions } from './store/navbar.actions';
import { selectTheme } from './store/navbar.selectors';

@Component({
  selector: 'app-navbar-header',
  templateUrl: './navbar-header.component.html',
  styleUrls: ['./navbar-header.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, ToastModule, SidebarModule, TranslateModule, ToggleButtonModule, DialogModule, ReactiveFormsModule, DropdownModule, NavNotificationsComponent, NavRegionalComponent, TrimStringPipe, OverlayPanelModule, NavCartComponent]
})

export class NavbarHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  // ? Dropdowns for ( Cart , Login & Register , User Settings )
  @ViewChild('mainCategoryOP') mainCategoryOP!: OverlayPanel;
  @ViewChild('loginOP') loginOP!: OverlayPanel;
  @ViewChild('userSettingOP') userSettingOP!: OverlayPanel;

  // ? Count Of Notifications Not Read
  unreadNotificationCount = 0;

  // ? Navbar state: shrink on scroll + light/dark theme
  isScrolled = false;
  isLight = false;

  cartQuantity$ = this._store.selectSignal(SelectCartQuantity);

  arabicLang = false;
  searchTerm!: string;

  searchCountriesKey = '';


  user!: IUser | null;
  email: any;
  alert: any;
  message: any;
  isLoggedOut = false;
  loadingNav = false;
  loading = false;
  isLoading$: any;

  productType = ProductType;
  searchInput: any;
  accountStatus = AccountStatus;
  userRank = Rank;
  exchange!: Exchange;
  exchangeRate: any;
  currency!: IActiveCurrency;
  mainCategories$: Observable<MainCategory[]> | any;

  selectedCurrency: IActiveCurrency = {
    key: Currency.EGP,
    value: 1,
  };

  currentUrl!: string;
  defaultAvatar = 'https://innostudio.de/fileuploader/images/default-avatar.png';
  subscription: Subscription = new Subscription();
  mainCategoryList?: MainCategory1[];
  changeToCurrentLanguage: any;
  listLinksNav: boolean = false;
  currencyListNav: boolean = false;
  loginListNav: boolean = false;
  userListNav: boolean = false;
  screenWidth!: number;
  disableCurrency = false;
  wallets: any;
  selectedWallet!: Partial<IWallet>;

  newOrNo = false;
  exchangeTwo!: any;
  disableSearch = false;
  lang = '';
  arabic = false;
  country: any;
  countryCode: any;
  showWallet = false;

  user$ = this._store.selectSignal(SelectUser);
  userLogin$ = this._store.selectSignal(SelectUserStatus);
  language$ = this._store.selectSignal(SelectRegionalLanguage);

  langCode$ = computed<LangCode>(() => this.language$() as LangCode);
  currency$ = this._store.selectSignal(SelectRegionalCurrency);

  theme$ = this._store.selectSignal(selectTheme);
  desktopLogoSrc = computed(() => `assets/images/main/card4games-logo-for-${this.theme$()}-bg.svg`)
  phoneLogoSrc = computed(() => `assets/images/main/card4games-icon-for-${this.theme$()}-bg.svg`)


  constructor(
    private storeChangesServ: StoreChangesService,
    private userStore: UserStoreProvider,
    private router: Router,
    private messageService: MessageService,
    private loadingSpinnerService: LoadingSpinnerService,
    private exchangeServ: ExchangeService,
    private authService: AuthService,
    private walletServ: WalletService,
    private categoryService: CategoryService,
    private crispChatService: CrispChatService,
    public _languageService: LanguageService,
    private _browserService: BrowserService,
    private _store: Store,
    private _lightModeService: LightModeService
  ) {
    this.isLoading$ = this.loadingSpinnerService.isLoading$;
    this.getScreenSize();

    effect(() => {
      if (this.user$()?._id) {
        this.getValidUser();

        console.log(this.theme$());
        // ! Logout User 
        if (!this.userLogin$()) {
          this.logout();
          this.storeChangesServ.resetLogOutFromProfile();
        }

      }
      if (this.currency$() && this.user$()?._id) {
        this.getWallets()
      }
    })
  }

  ngOnInit(): void {

    this.initTheme();

    this.getNotificationCount();

    this.checkRoute(this.router.url);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkRoute(this.router.url);
      }
    });

    this.getAllMainCategories();

  }

  ngAfterViewInit(): void {
    this._browserService.getWindow()?.addEventListener('scroll', this.closeOnScroll.bind(this), true);
  }

  // ? Shrink navbar on scroll (hysteresis 10 / 40 to avoid flicker)
  @HostListener('window:scroll')
  onWindowScroll() {
    const w = this._browserService.getWindow();
    if (!w) return;
    const y = w.scrollY;
    if (!this.isScrolled && y > 40) {
      this.isScrolled = true;
    } else if (this.isScrolled && y < 10) {
      this.isScrolled = false;
    }
  }

  // ? Theme (light / dark)
  toggleTheme() {
    this.applyTheme(!this.isLight);
    this._store.dispatch(ThemeActions.toggleTheme({ theme: this.isLight ? 'light' : 'dark' }))
  }

  private initTheme() {
    const w = this._browserService.getWindow();
    if (!w) return;
    let saved: string | null = null;
    let legacyLightMode: string | null = null;
    try {
      saved = w.localStorage.getItem('theme');
      legacyLightMode = w.localStorage.getItem('lightMode');
    } catch { }
    // Check both keys: 'theme' (new) and 'lightMode' (legacy LightModeService)
    const isLight = saved === 'light' || (saved === null && legacyLightMode === 'true');
    this.applyTheme(isLight);
  }

  private applyTheme(light: boolean) {
    this.isLight = light;
    const w = this._browserService.getWindow();
    if (!w) return;
    // Apply data-theme on <html> for navbar-scoped CSS custom props
    w.document.documentElement.setAttribute('data-theme', light ? 'light' : 'dark');
    // Sync with LightModeService so .light-mood class is applied to .app div
    this._lightModeService.lightMood.next(light);
    try {
      w.localStorage.setItem('theme', light ? 'light' : 'dark');
      w.localStorage.setItem('lightMode', light ? 'true' : 'false');
    } catch { }
  }

  // ? Close Dropdowns On Scroll
  closeOnScroll() {
    if (this.mainCategoryOP?.overlayVisible) {
      this.mainCategoryOP.hide();
    }
    if (this.loginOP?.overlayVisible) {
      this.loginOP.hide();
    }
    if (this.userSettingOP?.overlayVisible) {
      this.userSettingOP.hide();
    }
  }

  getNotificationCount() {
    this.storeChangesServ.getReadNotificationsCount().pipe(
      filter(count => count !== null),
      tap(
        count => {
          this.unreadNotificationCount = count;
        }
      )
    ).subscribe();
  }

  goToSignin() {
    this.loginListNav = false;
    setTimeout(() => {
      this.router.navigate([`/${this.language$()}/auth/signin`]);
    }, 0);
  }

  goToSignup() {
    this.loginListNav = false;
    setTimeout(() => {
      this.router.navigate([`/${this.language$()}/auth/signup`]);
    }, 0);
  }

  getWalletShow() {
    this.storeChangesServ.getWalletShow().subscribe(response => {
      this.showWallet = response;
    });
  }

  isOnCheckoutRoute(): boolean {
    return this.router.url.includes('/checkout');
  }

  getWallets() {
    this.subscription.add(
      this.walletServ.getUserWallets().subscribe({
        next: (response) => {
          if (response && response.length) {
            this.wallets = sortWallets(response, this.currency$()).filter((item: IWallet) => {
              return item.currency === this.currency$();
            });
          }
          if (this.wallets?.length > 0) {
            this.selectedWallet = this.wallets[0];
            this.storeChangesServ.setSelectedWallet(this.selectedWallet);
          } else {
            this.selectedWallet = {
              balance: 0,
              currency: this.currency$(),
            };
          }

        },
      })
    );
    this.storeChangesServ.getSelectedWallet().pipe(
      filter(wallet => wallet !== null),
      tap(
        wallet => {
          this.selectedWallet = wallet;
        }
      )
    ).subscribe(noop);
  }

  private checkRoute(url: string): void {
    if (url === '/checkout') {
      this.disableCurrency = true;
    } else {
      this.disableCurrency = false;
    }
    if (url.includes('/search')) {
      this.disableSearch = true;
    } else {
      this.disableSearch = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    const windowBr = this._browserService.getWindow();
    if (windowBr) {
      this.screenWidth = window.innerWidth;
    }
  }

  getAllMainCategories() {
    if (this._browserService.getWindow()) {
      if (window.innerWidth <= 768) {
        const query = "?sort=order";
        this.categoryService.getUserMainCategories(query).subscribe((response) => {
          this.mainCategoryList = response.data;
        });
      }
    }
  }

  getValidUser() {
    this.getWallets();
    this.getWalletShow();
    this.loadingNav = true;
  }

  public getDate(date?: string): string {
    return date ? getDateSubtraction(date) : '';
  }

  searchResult(): void {
    if (this.searchTerm) {
      this.router.navigate([`/${this.language$()}/search`], {
        queryParams: { name: this.searchTerm },
      });
    }
  }

  clearSearch() {
    this.searchTerm = '';
  }


  mainCategoriesLocal(mainCategoryName: {}) {
    sessionStorage.setItem('mainCategoryNameFromNavbar', JSON.stringify(mainCategoryName));
  }


  logout(route?: string) {
    this._store.dispatch(UserActions.userLogin({ login: false }));
    this._store.dispatch(UserActions.userLogout());
    this.crispChatService.crispChat.next('reset');
    this.storeChangesServ.setLoginSecret('');
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'You are Logout Successfully',
    });
    this.router.navigateByUrl('/');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this._browserService.getWindow()?.removeEventListener('scroll', this.closeOnScroll.bind(this), true);
  }
}


type LangCode = 'ar' | 'en';